import { useCallback } from "react";
import { useParams } from "react-router-dom";

import { useDialogsProvider } from "2g-dialogs-provider";
import ZpracDialog from "2g-zprac-dialog";

import { DATA } from "b2b/api";

import useMessages from "../i18n/useMessages";

export default function useSubmit(onSuccess) {
  const { showDialog, hideDialog } = useDialogsProvider();
  const { submitDialogTitle } = useMessages();
  const { id } = useParams();

  const handleSuccess = useCallback(() => {
    hideDialog();
    onSuccess();
  }, [hideDialog, onSuccess]);

  return useCallback(
    ({ values }) => {
      const { obrazek, prilohy, ...restValues } = values || {};

      const payload = {
        provozniInformace: JSON.stringify(restValues)
      };
      const obrazekPayload = obrazek?.filter(obr => !obr.key);
      if (obrazekPayload?.length > 0) {
        payload.obrazek = obrazekPayload;
      }
      const prilohyPaylod = prilohy?.filter(priloha => !priloha.key);
      if (prilohyPaylod?.length > 0) {
        payload.prilohy = prilohyPaylod.map(
          priloha =>
            new File([priloha], encodeURIComponent(priloha.name), {
              type: priloha.type,
              lastModified: priloha.lastModified
            })
        );
      }

      showDialog(ZpracDialog, {
        url: DATA.provozniInformace(id),
        method: "form",
        payload,
        options: {
          method: id !== undefined ? "put" : "post",
          contentType: "multipart/form-data"
        },
        title: submitDialogTitle(),
        onSuccess: handleSuccess,
        onClose: hideDialog
      });
    },
    [id, showDialog, hideDialog, handleSuccess, submitDialogTitle]
  );
}
